import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add"; // Icon for the create button
import CriarSorteioModal from "../CriarSorteioModal";

export type SystemType = "ANUNCIO360" | "ESCALA11";

interface CriarSorteioProps {
  token: string;
  role: "MASTER" | "PARTNER" | "ANALYST";
  onSorteioCreated: () => void;
  system: SystemType;
}

const CriarSorteio: React.FC<CriarSorteioProps> = ({
  token,
  role,
  onSorteioCreated,
  system,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSorteioCreationSuccess = () => {
    handleCloseModal(); // Close the modal
    onSorteioCreated(); // Notify the parent component to refresh the list
  };

  const escala11ButtonStyle = {
    backgroundColor: "#008870",
    "&:hover": {
      backgroundColor: "#005848ff",
    },
  };

  const isEscala11 = system === "ESCALA11";

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={isEscala11 ? escala11ButtonStyle : {}}
        >
          Criar Novo Sorteio
        </Button>
      </Box>

      {/* Render the creation modal */}
      <CriarSorteioModal
        open={openModal}
        onClose={handleCloseModal}
        token={token}
        onSorteioCreated={handleSorteioCreationSuccess}
      />
    </Box>
  );
};

export default CriarSorteio;
